<ion-header><bones-tt-page-header title="Cookies"></bones-tt-page-header></ion-header>

<ion-content>

  <ion-card class="ion-padding">
    <ion-card-title>Cookies</ion-card-title>
    <ion-list>
      <ion-item *ngFor="let cookie of cookies">
        <ion-label>
          <h2>{{ cookie.key }}</h2>
          <h3>{{ cookie.value }}</h3>
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-card>

</ion-content>
